
export const initialState = {
  insurances: [],
  }